import React from "react";
import logo from '../img/app-logo.png';

export const Logo = () => {
    return (
        <img
            src={logo}
            alt="Tennisphere logo"
            height={50}
        />
    );
};
